import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { ProcessSelectOption } from '../widgets/terminal/process-selection/process-selection.model';
import { TranslationService } from '@sdbn/common';
import { TileDefinition } from '../widgets/terminal/tile-selection/tile-selection.model';

export class DictionaryLookupSelectionController extends AbstractStepController {

    translationService: TranslationService;

    constructor(
    ) {
        super();
        this.translationService = WizardServiceLocator.injector.get(TranslationService);

    }

    onContextChange(contextChange: ContextChange) {
        if (contextChange.key === 'selectedTile') {
            this.handleSelectedProcessOption(this.dashboardContext.getContextValue('selectedTile'));
        }
    }

    onRegisterToDashboardContext() {
    }

    private handleSelectedProcessOption(selectedTile: TileDefinition) {
        this.wizardComponent.stopInactivityMonitoring();
        let targetField = this.wizardComponent.currentStep.dashboardConfiguration.targetField;
        this.dashboardContext.setContextValue(targetField, selectedTile.key);
        this.wizardComponent.next();
    }

    public handleFlow(): FlowStepHandleResult {

        let keys = this.translationService.getDictionaryKeysStartingWith(this.wizardComponent.currentStep.dashboardConfiguration.dictionaryKey);
        let restrictOptions: Array<string> = this.wizardComponent.currentStep.dashboardConfiguration.restrictOptions;
        let configuration = { selectOptions: new Array<TileDefinition>() }

        for (const key of keys) {
            let keyParts = key.split('.');
            if(restrictOptions != null && restrictOptions.length > 0) {
                if(restrictOptions.includes(keyParts[keyParts.length-1])) {
                    configuration.selectOptions.push(new TileDefinition({ titleDictionaryKey: key, key: keyParts[keyParts.length-1]}));
                }
            } else {
                configuration.selectOptions.push(new TileDefinition({ titleDictionaryKey: key, key: keyParts[keyParts.length-1]}));
            }

        }


        this.dashboardContext.setContextValue('dashboardConfiguration', configuration);

        // this.wizardComponent.startInactivityMonitoring();
        // const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        // logContainer.addLog('registration type selection started');

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    private cancel() {
        const matDialog = WizardServiceLocator.injector.get(MatDialog);
        const dialogData: ConfirmDialogData = {
            titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
            messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
            confirm: () => {
                this.wizardComponent.stopInactivityMonitoring();
                this.wizardComponent.restartWizard();
            }
        };
        matDialog.open(ConfirmDialogComponent, {
            data: dialogData
        });
    }

    public getControls(): StepControl[] {

        const controls = new Array<StepControl>();

        const spacer = new StepControl();
        spacer.type = StepControlType.SPACER_GROW;
        controls.push(spacer);

        const cancelControl = new StepControl();
        cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
        cancelControl.type = StepControlType.BUTTON_STROKED;
        cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
        cancelControl.controlAction = this.cancel.bind(this);
        controls.push(cancelControl);

        return controls;
    }
}
